module.exports = __webpack_public_path__ + "media/images/icons/flags/AE-9f04d230abffb12007984c568546956b.svg";